import React, { memo, useState } from "react";
import { FixedTop } from "@al/akui-mobile";
import { WithReduxHocPropsType, useCtx, withRedux } from "@al/next/al-ex";

import { tracker } from "~/common/tracker";
import { getTrackerSaReportInfo } from "~/pages/product/sensor-config";
import linkTo from "~/common/utils/linkTo";

import { adjustLink } from "../../constants";
import { ChannelType, CreativeId } from "../../types";
import { Props } from "../Description/types";

import close from "./close.png";
import styles from "./index.scss";

interface AdProps extends WithReduxHocPropsType, Props {
  className?: string;
  bottom?: React.ReactNode;
  height?: string;
  adInfo: { image: string; id: string };
  deepLink: string;
}

const Ad = (props: AdProps): JSX.Element => {
  const [visible, setVisible] = useState(true);
  const { spuId, skuId, deepLink } = props;
  const ctx = useCtx();
  const onClick = (): void => {
    linkTo(adjustLink[ChannelType.Ad](deepLink, String(spuId), String(skuId), String(CreativeId)));
    tracker.click({
      sa: {
        ...getTrackerSaReportInfo({ page: "homePage", eventName: "clickAd" }),
        commodityID: spuId,
        channel: ctx.query?.channel,
        advertisingID: props.adInfo.id,
      },
    });
  };
  return (
    <>
      {visible && (
        <FixedTop height={props.height || "0.6rem"} fixedClassName={styles.fixed_wrap}>
          <div className={styles.link} onClick={onClick}>
            <img className={styles.logo} src={props.adInfo.image} />
          </div>
          <img
            src={close}
            className={styles.close}
            onClick={() => {
              setVisible(false);
            }}
          />
          {props.bottom}
        </FixedTop>
      )}
    </>
  );
};

export default withRedux((state) => ({
  deepLink: state.static.deepLink,
}))(memo(Ad));
